import React from "react";
import { NavLink } from "react-router-dom";
import { LayoutDashboard, Clock, Plane, Receipt, Inbox } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const MobileTabBar = () => {
  const { hasPermission } = useAuth();
  const items = [
    { to: "/staff", label: "Acasă", icon: LayoutDashboard, end: true },
    { to: "/staff/pontaj", label: "Pontaj", icon: Clock, show: hasPermission("timesheet.self") },
    { to: "/staff/timeoff", label: "Concedii", icon: Plane },
    { to: "/staff/decontari", label: "Deconturi", icon: Receipt },
    { to: "/staff/cereri", label: "Cereri", icon: Inbox },
  ].filter((i) => i.show !== false);

  return (
    <nav className="pio-tabbar md:hidden" data-testid="mobile-tabbar" aria-label="Navigare rapidă">
      {items.map(({ to, label, icon: Icon, end }) => (
        <NavLink
          key={to}
          to={to}
          end={end}
          data-testid={`tab-${label.toLowerCase().replace(/ă/g, "a")}`}
          className={({ isActive }) => `pio-tab-item ${isActive ? "is-active" : ""}`}
        >
          <span className="pio-tab-ico"><Icon /></span>
          <span>{label}</span>
        </NavLink>
      ))}
    </nav>
  );
};
